
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 17">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.8357 16.1963L18.797 9.26209C19.0677 8.78762 19.0677 8.21238 18.797 7.73791L14.8357 0.803697C14.5549 0.309051 14.0175 0.00110588 13.4332 0H5.56677C4.98247 0.00110589 4.44508 0.309051 4.16425 0.803697L0.202987 7.73791C-0.0676625 8.21238 -0.0676625 8.78762 0.202987 9.26209L4.16425 16.1963C4.44508 16.6909 4.98247 16.9989 5.56677 17H13.4332C14.0175 16.9989 14.5549 16.6909 14.8357 16.1963ZM17.5808 8.39129C17.6194 8.45906 17.6194 8.54117 17.5808 8.60893L13.6265 15.5431C13.5865 15.6137 13.5099 15.6577 13.4265 15.6579H5.57349C5.49015 15.6577 5.41351 15.6137 5.37353 15.5431L1.41922 8.60893C1.38063 8.54117 1.38063 8.45906 1.41922 8.39129L5.37353 1.45708C5.41345 1.38639 5.4901 1.34232 5.57349 1.34211H13.4265C13.5099 1.34232 13.5865 1.38639 13.6265 1.45708L17.5808 8.39129ZM9.44022 11.9926C7.39262 11.9926 5.73291 10.3904 5.73291 8.41366C5.73291 6.43696 7.39262 4.83471 9.44022 4.83471C11.4876 4.83471 13.1475 6.43696 13.1475 8.41366C13.1475 10.3904 11.4876 11.9926 9.44022 11.9926ZM11.7573 8.41366C11.7573 9.64907 10.7199 10.6505 9.44022 10.6505C8.1605 10.6505 7.12315 9.64907 7.12315 8.41366C7.12315 7.17825 8.1605 6.17682 9.44022 6.17682C10.7199 6.17682 11.7573 7.17825 11.7573 8.41366Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Set',
    }) as DefineComponent
    </script>
    